/* eslint-env browser */
/* eslint-disable react/jsx-no-target-blank */

import React from 'react';
import PureComponent from 'react-pure-render/component';
import { connect } from 'react-redux';
import { replace } from 'redux-router';
import { Link } from 'react-router';
import has from 'lodash/has';
import each from 'lodash/each';
import { loadSignUp, signUpUser, setHeader, setFlashMessage, removeFlashMessage, removeErrorMessage, validateLoginState, logout } from 'actions';

import Loading from 'components/common/Loading';

import Input from '@klarna/ui/uncontrolled/Input';
import * as UncontrolledSwitch from '@klarna/ui/uncontrolled/Switch';

import ReCAPTCHA from "react-google-recaptcha";

class SignUpPage extends PureComponent {
  static loadData(props) {
    props.loadSignUp( (response, dispatch) => {

      },
      (error, dispatch) => {
        if (has(error, 'error_msgs[0]')) {
          props.setFlashMessage(error.error_msgs.join('. '), 'error');
          // setTimeout(() => props.removeFlashMessage(), 5000);
          props.replace('/calendar');
        }
      }
    );
  }

  static updateHeader(props) {
    // const { id, code } = props;
    // props.setHeader('Edit Event', false, '', <Link to={`/calendar/details/${event_id}`}>Cancel</Link>);
    props.setHeader(false);
  }

  constructor(props) {
    super(props);

    this.state = {
      email: '',
      first_name: '',
      last_name: '',
      terms_agree: '',
      'g-recaptcha-response': '',
    };
  }

  componentWillMount() {
    SignUpPage.loadData(this.props);
    SignUpPage.updateHeader(this.props);

    this.handleSignUp = this.handleSignUp.bind(this);

    // Check for a saved session and validate it's still valid
    const authToken = window.persistStore.getItem('auth_token');
    const userId = window.persistStore.getItem('user_id');
    if (authToken && userId) {
      this.props.validateLoginState(authToken, userId, () => {
        this.props.replace('/calendar');
      }, () => {
        this.props.logout();
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    /*
    let loadData = false;

    if (nextProps.security_question && nextProps.security_question !== this.props.security_question) {
      loadData = true;
    }

    if(loadData) {
      this.props.removeErrorMessage();
      SignUpPage.loadData(nextProps);
    }
    */

    if(!nextProps.isLoading) {

      let setState = false;

      if(setState) {
        this.setState({
          'g-recaptcha-response': '',
        });
      }

      if (nextProps.data.id > '') {
        this.props.removeErrorMessage();
        // nextProps.setFlashMessage('Signed Up Successfully');
        // setTimeout(() => nextProps.removeFlashMessage(), 5000);
        // nextProps.replace('/calendar');
      }
    }
  }

  handleSignUp(event) {
    event.preventDefault();

    var error_msgs = [];

    /*if(this.state.password != this.state.retype_pass) {
      error_msgs.push('Please type the same password in both fields.');
    } else if(this.state.password.length < 1) {
      error_msgs.push('Please provide a password.');
    }

    if(this.state.first_name.length < 1) {
      error_msgs.push('Please provide a first name.');
    }

    if(this.state.last_name.length < 1) {
      error_msgs.push('Please provide a last name.');
    }*/

    if(error_msgs.length > 0) {
      this.props.setFlashMessage(error_msgs.join('. '), 'error');
    } else {
      this.props.signUpUser(
        {
            email: this.state.email,
            first_name: this.state.first_name,
            last_name: this.state.last_name,
            terms_agree: this.state.terms_agree,
            'g-recaptcha-response': this.state['g-recaptcha-response'],
        },
        (response, dispatch) => {
          this.props.removeErrorMessage();
          //this.props.setFlashMessage('A confirmation email has been sent to: ' + this.state.email + ' .  Please read the email for instructions on activating your account.');
          // this.props.replace('/login');
        },
        (error, dispatch) => {
            //need to reload security question and answers
            SignUpPage.loadData(this.props);
        }
      );
    }
    return;
  }

  render() {
    if (this.props.isLoading) {
      return (
        <Loading withWrapper />
      );
    }

    const { id, email } = this.props;

    let tandemLogo = window.EXPANDED_APP_ROOT + 'img/tandem-logo-gray@2x.png';

    if (has(window.CONFIG, 'ui')) {
      if (window.CONFIG.ui === 'card') {
        tandemLogo = window.EXPANDED_APP_ROOT + 'img/tandem-logo2-gray@2x.png';
      }
    }

    if(id) {
      return (
        <section className="signup-page">
          <div className="card">
            
            <div className="header">
              <img src={tandemLogo} className="tandemLogo" alt="logo" />
            </div>

            <div className="signup-notice">
              <p>A confirmation email has been sent to: {email} .  Please read the email for instructions on activating your account.</p>
              <p>&nbsp;</p>
              <p><Link to="/calendar">View Calendar</Link></p>
              <p>&nbsp;</p>
              <p><Link to="/login">Login</Link></p>
            </div>

          </div>
        </section>
      );
    } else {
      return (
        <section className="signup-page">
          <div className="card">
            
            <div className="header">
              <img src={tandemLogo} className="tandemLogo" alt="logo" />
            </div>

            <form onSubmit={this.handleSignUp}>

               <div className="signup-fields">
                
                <div className="signup-field">
                  <Input
                    name="email"
                    type="email"
                    icon="email"
                    label="Email"
                    value={this.state.email}
                    onChange={(e) => this.setState({email: e.target.value})}
                  />
                </div>

                <div className="signup-field">
                  <Input
                    name="first_name"
                    icon="person"
                    label="First Name"
                    value={this.state.first_name}
                    onChange={(e) => this.setState({first_name: e.target.value})}
                  />
                </div>

                <div className="signup-field">
                  <Input
                    name="last_name"
                    icon="person"
                    label="Last Name"
                    value={this.state.last_name}
                    onChange={(e) => this.setState({last_name: e.target.value})}
                  />
                </div>

                <div className="signup-field">
                  <UncontrolledSwitch.Toggle
                    name="terms_agree"
                    onChange={isChecked => this.setState({terms_agree: isChecked})}
                  >
                    <span>I agree to Tandem's <a href="https://www.tandem.co/terms.php" target="_blank">terms and conditions</a> and <a href="https://www.tandem.co/privacy.php" target="_blank">privacy policy</a></span>
                  </UncontrolledSwitch.Toggle>
                </div>

                <div className="signup-field">
                  <ReCAPTCHA
                    ref="recaptcha"
                    sitekey={window.RECAPTCHA_SITE_KEY}
                    onChange={(e) => this.setState({'g-recaptcha-response': e})}
                  />
                </div>

              </div>

              <div className="signup-buttons">
                <button className="primary block" onClick={this.handleSignUp}>Sign Up</button>
              </div>
            </form>

          </div>
        </section>
      );
    }
  }
}

function mapStateToProps(state) {
  const data = state.signup;

  const { id, email, first_name, last_name, terms_agree } = data;

  let isLoading = true;

  if(data) {
    if(data.isLoading === false) {
      isLoading = false;
    }
  }

  return {
    id,
    email,
    first_name,
    last_name,
    terms_agree,
    'g-recaptcha-response': data['g-recaptcha-response'],
    isLoading,
    data,
  };
}

export default connect(mapStateToProps, {
  loadSignUp,
  signUpUser,
  setHeader,
  replace,
  setFlashMessage,
  removeFlashMessage,
  removeErrorMessage,
  validateLoginState,
  logout,
})(SignUpPage);



// WEBPACK FOOTER //
// ./src/app/containers/SignUpPage.js